import type { ValidateCouponResponse } from '@/hooks/billing/useValidateCoupon/types';

export const validateCoupon = async (): Promise<ValidateCouponResponse> => {
  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_API}v2/subscription/coupon/is-valid`,
      {
        credentials: 'include',
      }
    );

    const data = (await response.json()) as ValidateCouponResponse;

    return data;
  } catch {
    return {
      couponId: null,
      isValid: false,
    };
  }
};
